export const GET_DATA_ASO_REQUEST = "GET_DATA_ASO_REQUEST";
export const GET_DATA_ASO_SUCCESS = "GET_DATA_ASO_SUCCESS";
export const GET_DATA_ASO_FAILED = "GET_DATA_ASO_FAILED";

export const GET_ASO_BANNER_REQUEST = "GET_ASO_BANNER_REQUEST";
export const GET_ASO_BANNER_SUCCESS = "GET_ASO_BANNER_SUCCESS";
export const GET_ASO_BANNER_FAILED = "GET_ASO_BANNER_FAILED";
